<template>
  <!-- Modal para visualizar el PDF -->
  <b-modal hide-footer :title="title" ref="refModal" size="xl">
    <b-row v-if="dataModal">
      <!-- Detalles del adjunto -->
      <b-col sm="12" md="3">
        <div class="bg-light p-3 h-100">          
          <!-- Detalles generales: idioma, tipo, etc. -->
          <div class="mb-2">
            <strong>Producto:</strong>
            <p>{{ dataModal.product }}</p>
          </div>
          <!-- Datos del adjunto -->
          <div class="mb-2">
            <strong>Idioma:</strong>
            <span class="d-block">{{ getLanguage }}</span>
          </div>
          <div class="mb-2">
            <strong>Tipo:</strong>
            <span class="d-block">{{ getType }}</span>
          </div>
          <div class="mb-2">
            <strong>Fecha creación:</strong>
            <span class="d-block">{{ dataModal.attachment.created_at}}</span>
          </div>
          <div class="mb-2">
            <strong>Fecha actualización:</strong>
            <span class="d-block">{{ dataModal.attachment.updated_at }}</span>
          </div>
          <div class="mb-2">
            <strong>Descripción:</strong>
            <p>{{ dataModal.attachment.description }}</p>
          </div>
        </div>
      </b-col>

      <b-col sm="12" md="9">
        <div v-if="dataModal.file && !loadingAttachmentByProduct" class="h-100">

          <b-embed v-if="dataModal.file.path && dataModal.file.extension === 'pdf'" type="iframe" :src="dataModal.file.path" allowfullscreen></b-embed>
          <div v-else class="d-flex align-items-center justify-content-between p-3 shadow-sm">
            <div class="d-flex align-items-center">
              <i class="fa text-info" :style="{ fontSize: '40px' }" :class="getIconByExtensionFile()"></i>
              <p class="mt-3 mx-2">El archivo adjunto es un {{ dataModal.file.extension.toUpperCase() }}. <br /> Puedes descargarlo haciendo clic en el botón de descarga.</p>
            </div>
            <b-button
              variant="info"  
              :href="dataModal.file.path"
              :download="`${dataModal.product}-adjunto-${dataModal.attachment.id}.${dataModal.file.extension}`"
              target="_blank"
            >
              <i class="fa text-white fa-download" :style="{ fontSize: '20px' }"></i>
            </b-button>
          </div>
          
        </div>
        <div v-else-if="!dataModal.file && !loadingAttachmentByProduct" class="d-flex justify-content-center align-items-center h-100">
          <p class="text-muted">No hay adjunto disponible para visualizar</p>
        </div>
        <div v-if="loadingAttachmentByProduct" class="d-flex justify-content-center align-items-center h-100">
          Cargando...
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ModalVisualizerAttachment",

  props: {
    // Titulo del modal
    title: {
      type: String,
      required: false,
      default: "Visualizar adjunto",
    },
    // Datos del producto: { product: { ... }, attachment: { ... } }
    data: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      dataModal: null
    }
  },

  watch: {
    data: {
      handler(next, prev) {      
        if (next !== prev && next) {
          // Inicializar dataModal con los datos básicos inmediatamente
          this.initializeDataModal();
          
          this.downloadFileAttachment({
            id: this.data.attachment.id,
            nameProduct: this.data.product.nombre,
            download: false,
            callback: this.onHandleCallbackDownloadFileAttachment,
          });
        } else {
          this.dataModal = null;
        }
      },
      immediate: true
    },
  },

  computed: {
    ...mapState("adjuntos", ["loadingAttachmentByProduct"]),

    // Idioma del adjunto
    getLanguage() {
      try {
        return this.data &&
          this.data.attachment &&
          this.data.attachment.lista_idioma
          ? this.data.attachment.lista_idioma.lista
          : "No especificado";
      } catch (error) {
        return "No especificado";
      }
    },

    // Tipo de adjunto
    getType() {
      try {
        return this.data &&
          this.data.attachment &&
          this.data.attachment.tipo_adjunto
          ? this.data.attachment.tipo_adjunto.lista
          : "No especificado";
      } catch (error) {
        return "No especificado";
      }
    },

  },

  methods: {
    ...mapActions("adjuntos", ["downloadFileAttachment"]),

    showModal() {
      this.$nextTick(() => {
        if (!this.isModalReady()) return false;
        this.$refs.refModal.show();
      });
    },

    hideModal() {
      this.$nextTick(() => {
        if (this.isModalReady()) return false;
        this.$refs.refModal.hide();
      });
    },

    isModalReady() {
      return !!this.$refs.refModal;
    },

    // Inicializar dataModal con los datos básicos
    initializeDataModal() {
      if (!this.data || !this.data.product || !this.data.attachment) return;
      
      const { product, attachment } = this.data;
      
      this.dataModal = {
        product: product.nombre,
        attachment: {
          id: attachment.id,
          lista_idioma: attachment.lista_idioma,
          tipo_adjunto: attachment.tipo_adjunto,
          description: attachment.observacion,
          created_at: attachment.created_at,
          updated_at: attachment.updated_at,
        },
        file: null // Se actualizará cuando llegue el callback
      };
    },

    getIconByExtensionFile() {
      try {

        if (this.dataModal.file.extension === "xlsx") return 'fa-file-excel-o';
        else if (this.dataModal.file.extension === "docx") return 'fa-file-word-o';
        else if (this.dataModal.file.extension === "pptx") return 'fa-file-powerpoint-o';
        else if (this.dataModal.file.extension === "txt") return 'fa-file-text';
        else if (this.dataModal.file.extension === "json") return 'fa-json';
        else if (this.dataModal.file.extension === "png") return 'fa-image';

        return 'fa-file';

      } catch (error) {
        return 'fa-file';
      }
    },

    onHandleCallbackDownloadFileAttachment(status, response) {
      if (!status) return false;

      const { product, attachment } = this.data;

      this.dataModal = {
        product: product.nombre,
        attachment: {
          id: attachment.id,
          lista_idioma: attachment.lista_idioma,
          tipo_adjunto: attachment.tipo_adjunto,
          description: attachment.observacion,
          created_at: attachment.created_at,
          updated_at: attachment.updated_at,
        },
        file: {
          path: response.file,
          extension: response.extension,
        }
      };
    },
  },
};
</script>